module.exports = __webpack_public_path__ + "static/img/SF124_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/SF124_1.png
// module id = tY7u
// module chunks = 0